import { getDefaultMessages, iframeMessages } from 'services/iframeService';
import * as actions from 'redux/constants';
import { HOSTED_PAGE_TYPES } from 'consts';

const {
  sendStartMsg: sendViewPINPageActionStartMsg,
  sendSuccessMsg: sendViewPINActionSuccessMsg,
  sendFailMsg: sendViewPINActionFailedMsg
} = getDefaultMessages(HOSTED_PAGE_TYPES.cardIssuingResetPIN);

const viewPINMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.VIEW_PIN_START: {
      sendViewPINPageActionStartMsg();
      break;
    }
    case actions.VIEW_PIN_SUCCESS: {
      sendViewPINActionSuccessMsg({
        eventType: iframeMessages.VIEW_PIN_SUCCESS,
        meta: { closeIframe: false }
      });
      break;
    }
    case actions.VIEW_PIN_FAIL: {
      const { error } = action.payload;
      sendViewPINActionFailedMsg({
        eventType: iframeMessages.VIEW_PIN_FAIL,
        error,
        meta: { closeIframe: false }
      });
      break;
    }
    case actions.VIEW_PIN_SET_TIME_OUT: {
      const { data } = action.payload;
      sendViewPINActionSuccessMsg({
        eventType: iframeMessages.VIEW_PIN_SET_TIME_OUT,
        meta: { closeIframe: data }
      });
      break;
    }
  }

  next(action);
};

export default viewPINMiddleware;
